import { useFetchContainerTypesQuery } from '@api/Trinium/Endpoints/Lookups/slice';
import { ContainerType } from '@api/Trinium/Endpoints/Lookups/types';
import DisabledTooltip from '@components/DisabledTooltip';
import { FormikButtonDropdown } from '@forms/Components/Dropdowns/ButtonDropdown';
import PopupList from '@forms/Components/Dropdowns/List';
import { Field, useFormikContext } from 'formik';

import styles from '../Components/Form.module.css';
import { FormikAutocomplete } from '@forms/Components/AutocompleteInput';

interface ContainerTypeDropdownProps {
	fieldName: string;
	className?: string;
	isDisabled?: boolean;
	disabledReason?: string;
	disabledTooltipClass?: string;
	isRequired?: boolean;
}

export default function ContainerTypeDropdownField(props: ContainerTypeDropdownProps) {
	const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
	const { value } = getFieldMeta<string>(props.fieldName);

	const { data: sizes } = useFetchContainerTypesQuery(undefined);

	return (
		<DisabledTooltip
			message={props.isDisabled ? props.disabledReason : undefined}
			className={props.disabledTooltipClass}
		>
			<Field
				name={props.fieldName}
				label='Type'
				component={FormikButtonDropdown({
					ButtonContent: () => <span>{value || 'Select Type'}</span>,
					buttonContentProps: {},
					PopupContent: PopupList,
					popupContentProps: {
						items: sizes ?? [],
						getItemDisplay: (item: ContainerType) => item.type,
						onItemSelect: (value: ContainerType) => {
							void setFieldTouched(props.fieldName, true);
							void setFieldValue(props.fieldName, value.type, true);
						},
						className: styles['list-box-sm']
					}
				})}
				className={props.className}
				disabled={props.isDisabled}
				required={props.isRequired}
			/>
		</DisabledTooltip>
	);
}

export function ContainerTypeAutocompleteField({ fieldName, ...props }: ContainerTypeDropdownProps) {
	const { data: types } = useFetchContainerTypesQuery(undefined);

	return (
		<Field
			name={fieldName}
			label='Type'
			placeholder='Enter Type'
			component={FormikAutocomplete}
			className={props.className}
			autoCompleteItems={types?.map((s) => s.type) ?? []}
			disabled={props.isDisabled}
			required={props.isRequired}
		/>
	);
}
